// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__hJyf1","left":"styles_left__1NnYV"};